<template>
<div>
    <b-navbar toggleable="lg" type="dark" :style="'background-color:' + background +';'">
        <b-navbar-brand href="#">
            <button type="button" @click.prevent="TOGGLE_SIDEBAR"  class="btn btn-info">
                <b-icon icon="text-center" aria-hidden="true"></b-icon>
            </button>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav v-if="user.isAdmin !== 1">
                <b-nav-form class="search-container" @submit.prevent="searchItem">
                    <b-form-select 
                    v-model="typeSearchSelected" 
                    @change="updateSearchSelected()" 
                    class="custom-select"
                    >
                    <b-form-select-option value="1">-- Seleccione una opción --</b-form-select-option>
                    <b-form-select-option value="2">Item</b-form-select-option>
                    <b-form-select-option value="3">Nombre</b-form-select-option>
                    <b-form-select-option value="4">Código de barras</b-form-select-option>
                    </b-form-select>

                    <b-input-group class="search-box">
                    <vue-typeahead-bootstrap
                        v-model="searchText"
                        :data="item_search_autocomplete"
                        :serializer="serializarValor"
                        @hit="searchItem"
                        @keyup.enter.prevent="searchItem"
                        placeholder="Buscar items..."
                        :maxMatches="30"
                        @input="instantSearch"
                        class="custom-input"
                    />
                    <template v-slot:append>
                        <b-button variant="primary" class="custom-button" @click.prevent="searchItem">
                        <b-icon icon="search"></b-icon>
                        </b-button>
                    </template>
                    </b-input-group>
                </b-nav-form>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto" v-if="user.isAdmin !== 1">
                <b-nav-form>
                    <b-button size="sm" class="my-2 my-sm-0 text-white" variant="info" :disabled="cartItemCount < 1" @click.prevent="toCart()">
                        <b-icon icon="cart4" ></b-icon>
                        Canasta
                        <b-badge variant="danger" pill>{{cartItemCount}}</b-badge>
                    </b-button>
                </b-nav-form>
                <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template #button-content>
                        <b class="text-white">Perfil</b>
                    </template>
                    <div class="testx">
                    <b-dropdown-item-button>{{user.nombre}}</b-dropdown-item-button>
                    <b-dropdown-form>
                        <b-button variant="info" block size="sm" @click="dialog = true">Cambiar sucursal</b-button>
                    </b-dropdown-form>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item-button>
                        <b-button variant="light" block @click="logout">Salir</b-button>
                    </b-dropdown-item-button>
                    </div>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
    <template>
        <b-modal
            v-model="dialog"
            title="Ingrese sucursal a la canasta"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
            <b-form-select v-model="saveSucursal" :options="sucursales"
            text-field="nombre"
            value-field="id"
            >
            <template v-slot:first>
                <b-form-select-option value="" disabled>-- Por favor seleccione una Sucursal --</b-form-select-option>
            </template>
            
            </b-form-select>
            <template v-slot:modal-footer>
                <div class="w-100">
                <b-button variant="success" 
                :disabled="saveSucursal === ''"
                @click="storeSucursalInUserCart" block>
                    Guardar
                </b-button>
                </div>
            </template>
        </b-modal>
        </template>
    </div>
</template>

<script>
import {debounce} from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
     computed: {
        ...mapState('configuration', ['background', 'cartItemCount', 'sucursalSelected', 'sucursales', 'typeSearch']),
        ...mapState('auth', ['user']),
    },
    data(){
        return {
            clickeable: false,
            saveSucursal: '',
            searchText: '',
            dialog: false,
            typeSearchSelected: 1,
            item_search_autocomplete: [],
        }
    },
    created() {
        this.getUserCart();
    },
    methods: {
        ...mapMutations('configuration', ['TOGGLE_SIDEBAR']),
        ...mapMutations(['setLoading']),
        ...mapActions('auth', ['logout']),
        ...mapActions('configuration', {
          _getSucursalSelected: 'getSucursalSelected',
          _setTypeSearchSelected: 'setTypeSearchSelected'}
          ),
        searchItem(){
            this.$router.push({ 
                name: 'SearchItems', 
                params:{
                    texto: this.searchText, 
                    time: new Date().getTime(),
                    } 
                });
        },
        async getUserCart(){
            this.setLoading(true)
            await this.$conectar.post('/cart/get-user-cart')
            .then(response=>{
                if (response.data.error == true) { 
                    this.dialog= true;
                }
            })
            .catch(error => {
                console.log(error);
            })
            this.setLoading(false)
        },
        async storeSucursalInUserCart(){
            this.setLoading(true)
            let sucursalSelected = { id: this.saveSucursal}
            await this.$conectar.post('/cart/store-sucursal-user-cart', sucursalSelected)
            .then(response =>{
                if(response.data.error == false){
                    this._getSucursalSelected();
                    this.dialog= false;
                }
            })
            .catch(error => {
                console.log(error);
            })
            this.setLoading(false)
        },
        updateSearchSelected(){
            this._setTypeSearchSelected(this.typeSearchSelected);
        },
        toCart(){
            if(this.user.tipo_terceros == 1){
                this.$router.push({ name: 'processCartVendedor' });
            }else{
                this.$router.push({ name: 'processCartClienteWeb' });
            }
        },
        instantSearch: debounce(function() {
            this.item_search_autocomplete = [];
            if(this.typeSearchSelected == 1){
                let searchObject = { 
                    search: this.searchText
                }
                    
                this.$conectar.post('busqueda/instant-search-items', searchObject)
                .then(response =>{
                    if(response.data.error == false){
                        this.item_search_autocomplete = response.data.searchResults;
                    }
                })
                .catch(e => {
                    console.log(e.response);
                })
            }
        }, 500),
        
        serializarValor(item) {
			return item.nombre;
		},
        onArticuloSeleccionado(item) {
            this.instantSearch(item.nombre)
		}
    }
}
</script>

<style  scoped>
.testx {
    min-width: 15rem !important;
}
.list-group-item-action { 
  color: purple !important;
  width: 100%; /* Se adapta al contenedor */
  max-width: 500px; /* Máximo en pantallas grandes */
}

.search-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  flex-wrap: nowrap; /* ✅ No permite saltos de línea */
}

.custom-select {
  flex: 0 0 auto; /* ✅ No se expande ni se encoge */
  width: 220px;
  height: 100%;
  border-radius: 8px;
  border: 1px solid #ced4da;
}

.search-box {
  display: flex;
  flex: 1; /* ✅ Ocupa el espacio restante */
  align-items: center;
}

.custom-input {
  flex: 1; /* ✅ Se expande ocupando el espacio disponible */
  height: 100%;
  border-radius: 8px;
  border: 1px solid #ced4da;
  min-width: 150px; /* ✅ Evita que se vuelva muy pequeño */
  width: 600px;
}

.custom-button {
  flex: 0 0 auto; /* ✅ No se encoge */
  height: 100%;
  width: 50px;
  border-radius: 8px;
}

/* 📱 Ajustes para móviles */
@media all and (max-width: 768px) {
    .search-container {
        flex-wrap: wrap; /* ✅ En móviles sí permitimos salto de línea si es necesario */
        justify-content: center;
    }
    
    .custom-select {
        width: 100%;
        max-width: 250px;
    }
    
    .search-box {
        width: 100%;
        max-width: 400px;
    }
    
    .custom-input {
        width: 100%;
        max-width: 300px;
    }

    .custom-button {
        width: 50px;
    }
}



/* 📱 Ajustes para tablets */
@media all and (max-width: 1024px) {
    .list-group-item-action { 
        width: 100%;
        max-width: 220px;
    }

    .custom-input {
        width: 100%;
        max-width: 400px;
    }
}

/* 📱 Ajustes para laptops */
@media all and (max-width: 1300px) {
    .list-group-item-action { 
        width: 100%;
        max-width: 220px;
    }

    .custom-input {
        width: 100%;
        max-width: 400px;
    }
}

</style>